import axios from 'axios'
import history from '../history'


const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})

export async function postAddSubscriptionUser(idVaga, dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));

    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/job/addsubscriptionuser',
        {
            "opportunity_id": idVaga
        },
        {
            headers: {
                'Authorization': AuthToken
            }
        }).then(response => {
            successAddSubscriptionUser(response, idVaga, dispatch);
        }).catch(erro => {
            erroAddSubscriptionUser(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successAddSubscriptionUser(response, idVaga, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Vaga',
        description: 'Candidatura efetuada com sucesso'
    })
    history.push(`inicial`)
    history.push(`detalhes-vaga?id=${idVaga}`)
}

function erroAddSubscriptionUser(erro, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Vaga',
        description: 'Houve um erro ao tentar realizar caditatura'
    })
}